import React from "react";
import { Icon } from "antd";

const stateIcon = {
	1: <Icon type="save" theme="filled" />,
	2: <Icon type="play-circle" theme="filled" style={{ color: "#26a69a" }} />,
	3: <Icon type="check-circle" theme="filled" style={{ color: "#177245" }} />,
	4: <Icon type="clock-circle" theme="filled" style={{ color: "#ffca40" }} />,
};

export default stateIcon;
